import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    detailIdProp: 'vsId',
    detailUrl: '/DepVsDetail',
    listUrl: '/DepVsList',
    mapProp: 'map',
    name: '虚拟机',
    textProp: 'vsName',
    type: 'VR',
}
